<div class="maItemOptionsPopup" *ngIf="visible" [ngClass]="{'hidden': !visible}">
    <div class="gridItemMenu">                            
        <div class="gridItemMenuItem"
            [ngClass]="!hasPermission('WRITE') && isCxOne ? 'dropdown-item-disabled' : ''"
            (click)="!hasPermission('WRITE') && isCxOne ? $event.stopPropagation() : edit();">
            <div class="gridItemMenuItemIcon edit">
                <svg *ngIf="isCxOne" class="icon-16 fill-valyrianSteel fill-hover-whaleTail mr-1">
                    <use href="../../../App_Themes/CXone/icons/edit.svg#edit"></use>
                </svg>
            </div>
            <div class="gridItemMenuItemLabel" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Edit">Edit</div>
        </div>
        <div class="gridItemMenuItem"
            [ngClass]="!hasPermission('CREATE') && isCxOne ? 'dropdown-item-disabled' : ''"
            (click)="!hasPermission('CREATE') && isCxOne ? $event.stopPropagation() : copy();">
            <div class="gridItemMenuItemIcon duplicate">
                <svg *ngIf="isCxOne" class="icon-16 fill-valyrianSteel fill-hover-whaleTail mr-1">
                    <use href="../../../App_Themes/CXone/icons/copy.svg#copy"></use>
                </svg>
            </div>
            <div class="gridItemMenuItemLabel" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Copy">Copy</div>
        </div>
        <div class="gridItemMenuItem divider"></div>
        <div class="gridItemMenuItem"
            [ngClass]="!hasPermission('WRITE') && isCxOne ? 'dropdown-item-disabled' : ''"
            (click)="!hasPermission('WRITE') && isCxOne ? $event.stopPropagation() : delete($event);">
            <div class="gridItemMenuItemIcon delete">
                <svg *ngIf="isCxOne" class="icon-16 fill-valyrianSteel fill-hover-whaleTail mr-1">
                    <use href="../../../App_Themes/CXone/icons/delete.svg#delete"></use>
                </svg>
            </div>
            <div class="gridItemMenuItemLabel" runat="server" cvLocalizedText langSection="Manual_Awards" langKey="Delete">Delete</div>
        </div>
    </div>
</div>

